module.exports = __webpack_public_path__ + "static/media/point.db37d53e.svg";